import axios from "axios";
import { isBagelAdmin } from "../../utils";
import { CurrentUser } from "../auth";

const API_BASE_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN + "/global_collections/users";

export const updateUserAccountId = async (
  userId: string,
  newAccountId: string,
  currentUser: CurrentUser | null
) => {
  try {
    const isBagelUser = isBagelAdmin(currentUser);
    if (!isBagelUser) {
      throw new Error("You are not authorized to access this resource");
    }
    
    const response = await axios.post(
      `${API_BASE_URL}/update-account-id`,
      { userId, newAccountId }
    );
    return response.data.result;
  } catch (e) {
    console.error("Error updating user accountId", e);
    throw e;
  }
}; 